import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogoService {
  private width = new BehaviorSubject<string>('');

  setLogo(logo: string) {
    this.width.next(logo);
  }

  getLogo() {
    return this.width.asObservable();
  }

  constructor() {}
}
